<script setup lang="ts">
defineProps({
  count: {
    type: Number,
    default: 0,
  },
  label: {
    type: String,
    default: 'videos',
  },
});
</script>

<template>
  <div class="wrapper">
    <span class="counter">{{ count }}</span>
    <span v-if="label" class="label">{{ $t(label) }}</span>
  </div>
</template>

<style lang="postcss" scoped>
.wrapper {
  @apply text-dark-500;

  span.counter {
    @apply mr-1;
  }

  span {
    @apply text-sm;
  }
}
</style>
